import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import { useAuth } from "./AuthContext";
import { detectCurrency, resolveCurrency } from "../lib/pricingConfig";

const KEY = "dropit-currency";
const CurrencyContext = createContext({ currency: "NZD", auto: true, setCurrency: () => {} });

const phoneCountry = (uid) => {
  try {
    const p = JSON.parse(localStorage.getItem(`dropit-profile-${uid}`) || "null");
    return p?.phone ? parsePhoneNumberFromString(p.phone)?.country || null : null;
  } catch { return null; }
};

export function CurrencyProvider({ children }) {
  const { user } = useAuth();
  const [saved, setSaved] = useState(() => localStorage.getItem(KEY) || "");
  const [detected, setDetected] = useState(() => detectCurrency({ phoneCountry: user ? phoneCountry(user.id) : null }));

  useEffect(() => { setDetected(detectCurrency({ phoneCountry: user ? phoneCountry(user.id) : null })); }, [user]);

  const setCurrency = useCallback((code) => {
    if (!code || code === "auto") { localStorage.removeItem(KEY); setSaved(""); return; }
    const c = resolveCurrency(code); localStorage.setItem(KEY, c); setSaved(c);
  }, []);

  const value = useMemo(() => ({ currency: saved ? resolveCurrency(saved) : detected, auto: !saved, setCurrency }), [saved, detected, setCurrency]);
  return <CurrencyContext.Provider value={value}>{children}</CurrencyContext.Provider>;
}

export const useCurrency = () => useContext(CurrencyContext);
